import { OnSuggestionSelected } from 'react-autosuggest';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { IBaseSuggestion } from '@bridebook/ui/src/components/bbcommon/inputs/suggestion-field-v2/suggestion-field-v2';
import { fetchSupplierPromise } from '@bridebook/web/app-shared/lib/supplier/utils/fetch-supplier-promise';
import openInBrowser from '@bridebook/web/lib/utils/open-in-browser';

export const useReviewCallbacks = () => {
  const onCustomClick = () => {
    openInBrowser('https://bridebookuk.typeform.com/to/ms6Dl2');
  };

  const onSuggestionSelected =
    (
      callback: (supplier: ISupplier) => void,
    ): OnSuggestionSelected<IBaseSuggestion & { publicId: string }> =>
    async (_, selected) => {
      const { suggestion } = selected;

      if (!suggestion?.publicId) {
        return;
      }

      const json = await fetchSupplierPromise(suggestion.publicId);
      callback(json);
    };

  return { onCustomClick, onSuggestionSelected };
};
